import React, { useState } from "react";
import Card from "./Card";
import react from "../components/photos/react.png";
import nextjs from "../components/photos/nextjs.jpg";
import nextjslogo from "../components/photos/next-logo.png";
import reactlogo from "../components/photos/react-logo.png";
import javascriptlogo from "../components/photos/javascript-logo.png";
import html from "../components/photos/html.png";
import javascript from "../components/photos/javascript.png";
import java from "../components/photos/java.png";
import css from "../components/photos/css.png";
// import php from "../components/photos/php.png";
import react2 from "../components/photos/react2.png";
import nextjs2 from "../components/photos/nextjs2.png";
import tailwindcss from "../components/photos/tailwindcss.png";
import shopify from "../components/photos/shopify.png";
import sass from "../components/photos/sass.png";
import liquid from "../components/photos/liquid.png";
import jquery from "../components/photos/jquery.png";
import mssql from "../components/photos/sql.png";
import youtube from "../components/photos/youtube.png";
import linkedin from "../components/photos/linkedin.png";
import github from "../components/photos/github.png";
import mail from "../components/photos/mail.png";
import twitter from "../components/photos/twitter.png";
import speech from "../components/photos/speech.jpg";
import translate from "../components/photos/translate.jpg";
import portfolio from "../components/photos/portfolio.jpg";
import dropzone from "../components/photos/dropzone.jpg";
import udemylogo from "../components/photos/udemylogo.png";
import udemybanner from "../components/photos/udemybanner.png";
import mysql from "../components/photos/mysql.png";
import aı from "../components/photos/aı.png";

const tabs = ["Ventures", "Projects", "Tech Stack", "Connect"];

const links = [
  // { name: "Twitter/X", username: "@samar_jamil7", },
  { icon: youtube, name: "Youtube", username: "@demrelufuk", },
  { icon: twitter, name: "Twitter", username: "@demrelufuk", },
  { icon: linkedin, name: "Linkedin", username: "@UfukDemirel", },
  { icon: github, name: "Github", username: "@UfukDemrel", },
  // { name: "Contra", username: "samar_jamil", },
  { icon: mail, name: "Email", username: "demirelu544@gmail.com", },
  // { name: "Book a Call", username: "cal.com", },
];

export default function Tabs() {
  const [active, setActive] = useState("Ventures");

  const tools = [
    { name: "Html", icon: html },
    { name: "Javascript", icon: java },
    { name: "Css", icon: css },
    { name: "Shopify", icon: shopify },
    { name: "Liquid Code", icon: liquid },
    { name: "MsSQL", icon: mssql },
    { name: "MySQL", icon: mysql },
    { name: "Jquery", icon: jquery },
    { name: "React", icon: react2 },
    { name: "Next.Js", icon: nextjs2 },
    { name: "Tailwind.Css", icon: tailwindcss },
    { name: "Sass", icon: sass }
  ];

  return (
    <div className="tabs">
      <div className="tab-buttons">
        {tabs.map((t) => (
          <button
            key={t}
            className={active === t ? "active" : ""}
            onClick={() => setActive(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {active === "Ventures" && (
        <div className="cards">
          <Card
            logo={udemylogo}
            title="Udemy"
            desc="This MSSQL course builds your data management, querying, and analysis skills through real-world projects, guiding you from fundamentals to advanced."
            link="https://www.udemy.com/course/uygulama-ve-odevlerle-mssql-ogreniyorum-part-1/"
            img={udemybanner}
          />

          <Card
            logo={reactlogo}
            title="React"
            desc="Learn React step by step with hands-on projects, and build modern, responsive web applications from scratch easily."
            link="https://www.youtube.com/watch?v=Dh76vRl7i1w&feature=youtu.be"
            img={react}
          />
          <Card
            logo={nextjslogo}
            title="Next.JS"
            desc="Learn Next.js step by step, build fast and scalable web apps, and master modern full-stack development easily today."
            link="https://www.youtube.com/watch?v=hBidGIinQ8o&feature=youtu.be"
            img={nextjs}
          />
          <Card
            logo={javascriptlogo}
            title="Javascript"
            desc="Master JavaScript from basics to advanced with real projects, and create dynamic, interactive web experiences effortlessly."
            link="https://www.youtube.com/watch?v=DKFuSg3eKRw"
            img={javascript}
          />
        </div>
      )}

      {active === "Projects" && (
        <section className="projects-section">
          <div className="projects-wrapper">

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://www.udemy.com/course/uygulama-ve-odevlerle-mssql-ogreniyorum-part-1/" target="_blank" rel="noreferrer">
                <div className="project-image-wrapper">
                  <img src={udemybanner} alt="The MsSQL Journey" className="project-image" />
                </div>
                <div className="textsvg">
                  <div>
                    <h4 className="project-title">The MsSQL Journey</h4>
                    <p className="project-category">MsSQL, Microsoft SQL</p>
                  </div>
                  <div className="project-svg">
                    <svg
                      className="project-svg"
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                    </svg></div>
                </div>
              </a> 
            </div>

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://ai-cv-arena.vercel.app/" target="_blank" rel="noreferrer">
              <div className="project-image-wrapper">
                <img
                  src={aı}
                  alt="AI ATS Resume Analyzer"
                  className="project-image"
                />
              </div>
              <div className="textsvg">
                <div>
                  <h4 className="project-title">AI ATS Resume Analyzer</h4>
                  <p className="project-category">Next.Js, TypeScript, OpenAI API, React</p>
                </div>
                <div className="project-svg">
                  <svg
                    className="project-svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                  </svg>
                </div>
              </div>
              </a>
            </div>

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://www.youtube.com/watch?v=ZCFJDKjYfTg&t=1s" target="_blank" rel="noreferrer">
              <div className="project-image-wrapper">
                <img src={speech} alt="Speech Recognition" className="project-image" />
              </div>
              <div className="textsvg">
                <div>
                  <h4 className="project-title">Speech Recognition Book Website</h4>
                  <p className="project-category">React, Tailwind.CSS</p>
                </div>

                <div className="project-svg">
                  <svg
                    className="project-svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                  </svg></div>
              </div>
              </a>
            </div>

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://youtu.be/KSd3YNeXWak?si=_lxgzGL0vz42qg_x" target="_blank" rel="noreferrer">
              <div className="project-image-wrapper">
                <img
                  src={dropzone}
                  alt="Dropzone App"
                  className="project-image"
                />
              </div>
              <div className="textsvg">
                <div>
                  <h4 className="project-title">Dropzone Mail Website</h4>
                  <p className="project-category">Node Js, Express, React</p>
                </div>
                <div className="project-svg">
                  <svg
                    className="project-svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                  </svg>
                </div>
              </div>
              </a>
            </div>

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://youtu.be/8koPfnC1qvU?si=LfX6s6LryDH7sbXN" target="_blank" rel="noreferrer">
              <div className="project-image-wrapper">
                <img
                  src={translate}
                  alt="Translate App"
                  className="project-image"
                />
              </div>
              <div className="textsvg">
                <div>
                  <h4 className="project-title">
                    React, Next JS Translate Website
                  </h4>
                  <p className="project-category">(React, Tailwind.CSS)</p>
                </div>
                <div className="project-svg">
                  <svg
                    className="project-svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                  </svg>
                </div>
              </div>
              </a>
            </div>

            <div className="project-card">
              <a style={{ textDecoration: "none" }} href="https://youtu.be/r_WGBSofS0Q?si=T7xkxeivROt4L_FZ" target="_blank" rel="noreferrer">
              <div className="project-image-wrapper">
                <img
                  src={portfolio}
                  alt="Portfolio"
                  className="project-image"
                />
              </div>
              <div className="textsvg">
                <div>
                  <h4 className="project-title">
                    Porfolio Website Creation
                  </h4>
                  <p className="project-category">Next Js, React, TailwindCSS</p>
                </div>
                <div className="project-svg">
                  <svg
                    className="project-svg"
                    width="13"
                    height="13"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M12 4C11.4477 4 11 3.55228 11 3C11 2.44772 11.4477 2 12 2L20 2C21.1046 2 22 2.89543 22 4V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V5.39343L3.72798 21.6655C3.33746 22.056 2.70429 22.056 2.31377 21.6655C1.92324 21.2749 1.92324 20.6418 2.31377 20.2512L18.565 4L12 4Z" fill="#0F0F0F" />
                  </svg>
                </div>
              </div>
              </a>
            </div>
          </div>
          <div style={{ width: "100%", textAlign: "center", marginTop: "5%" }}>
          <a href="https://www.youtube.com/@demrelufuk/videos" target="_blank" rel="noreferrer" className="visit-link">
            Visit site <span className="arrow">→</span>
          </a>
          </div>

        </section>
      )}

      {active === "Tech Stack" && (
        <section className="techstack">
          <div className="techstack-grid">
            {tools.map((tool) => (
              <div key={tool.name} className="techstack-card">
                <img src={tool.icon} alt={tool.name} className="techstack-icon" />
                <span className="techstack-name">{tool.name}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {active === "Connect" && (
        <section className="connect">
          <div className="connect-list">
            {links.map((link) => (
              <div
                key={link.name}
                className={`connect-item ${link.active ? "active" : ""}`}
              >
                <div className="connect-left">
                  <img src={link.icon} alt={link.name} className="connect-icon" />
                  <span className="connect-name">{link.name}</span>
                </div>
                <span className="connect-username">{link.username}</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
